export const StorageKeys = {
  TENANT: "tenant",
  // { providerId } the guest chose before the services, on a tenant with several providers;
  // a null providerId is „Bárki” (docs/MULTI_PROVIDER.md).
  SELECTED_PROVIDER: "selectedProvider",
  SELECTED_SUPPLY: "selectedSupply",
  SELECTED_APPOINTMENT: "selectedAppointment",
  TARGET_ROUTE_BEFORE_REDIRECT: "targetRouteBeforeRedirect",
  IS_USER_AUTHENTICATED: "isUserAuthenticated",
  BOOKING_TO_BE_CANCELLED: "bookingToBeCancelled",
  // { token, email, purpose, sentAt } of a registration or password reset waiting for its code.
  EMAIL_VERIFICATION: "emailVerification"
};